import React, { Component } from 'react';
import '../../css/App.css';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import {formatCurrency} from "../../util";

import { translate } from "../../i18n/customI18nProvider";

class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dateBegin: null,
            dateEnd: null,
            bar_id: null
        };
    }

    componentDidMount() {
        const pname = window.location.pathname.split("/");
        let urlParams = new URLSearchParams(window.location.search);

        let dateBegin = null;
        let dateEnd = null;
        let bar_id = null;

        if(pname.length === 3) {
            bar_id = pname[2];
            dateBegin = null;
            dateEnd = null;
        } 
        if(urlParams.get('dateBegin') && urlParams.get('dateEnd')) {
            dateBegin = urlParams.get('dateBegin');
            dateEnd = urlParams.get('dateEnd');
        }

        this.setState({
            dateBegin: dateBegin,
            dateEnd: dateEnd,
            bar_id: bar_id
        })

    }

    render(){
        let column1 = [];
        column1.push([formatCurrency(this.props.statistics.credit_cash || 0), translate('custom.loadings') + " cash"])
        column1.push([formatCurrency(this.props.statistics.credit_twint_web || 0), translate('custom.loadings') + " TWINT (" + translate('custom.online') + ") "])
        column1.push([formatCurrency(this.props.statistics.credit_twint_app || 0), translate('custom.loadings') + " TWINT (" + translate('custom.cash_register') + ") "])
        column1.push([formatCurrency(this.props.statistics.credit_twint_other || 0), translate('custom.loadings') + " TWINT (" + translate('custom.other') + ") "])
        column1.push([formatCurrency(this.props.statistics.credit_card_web || 0), translate('custom.loadings') + " " + translate('custom.cards') + " (" + translate('custom.online') + ") "])
        column1.push([formatCurrency(this.props.statistics.credit_card_app || 0), translate('custom.loadings') + " " + translate('custom.cards') + " (" + translate('custom.cash_register') + ") "])
        column1.push([formatCurrency(-this.props.statistics.refund_cash || 0), translate('custom.cash_refund')])
        column1.push([formatCurrency(-this.props.statistics.refund_form || 0), translate('custom.form_refund')])
        column1.push([formatCurrency(-this.props.statistics.refund_twint || 0), translate('custom.twint_refund')])
        column1.push([formatCurrency(-this.props.statistics.refund_card_web || 0), translate('custom.card_refund')])
        column1.push([formatCurrency(-this.props.statistics.refund_card_app || 0), translate('custom.mypos_card_refund')])
        column1.push([formatCurrency(this.props.statistics.credit_cash_hybrid || 0), translate('custom.hybrid_cash')])
        column1.push([formatCurrency(this.props.statistics.credit_twint_hybrid || 0), translate('custom.hybrid_twint')])
        column1.push([formatCurrency(this.props.statistics.credit_card_hybrid || 0), translate('custom.hybrid_mypos')])
        column1.push([formatCurrency(this.props.statistics.debit_mypos_direct || 0), translate('custom.mypos_direct.statistics.payment')])
        column1.push([formatCurrency(-this.props.statistics.credit_mypos_direct || 0), translate('custom.mypos_direct.statistics.refund')])

        let column2 = [];
        column2.push([formatCurrency(this.props.statistics.entrance || 0), translate('custom.entrances')])
        column2.push([formatCurrency(this.props.statistics.consumption || 0), translate('custom.consumptions')])
        column2.push([formatCurrency(this.props.statistics.deposit || 0), translate('custom.deposit')])
        column2.push([formatCurrency(-this.props.statistics.deposit_return || 0), translate('custom.deposit_return')])
        column2.push([formatCurrency(this.props.statistics.deposit_non_refundable || 0), translate('custom.deposit_non_refundable')])
        column2.push([formatCurrency(this.props.statistics.sold_cash || 0), translate('custom.bracelets_balance')])
        column2.push([formatCurrency(this.props.statistics.sold_twint || 0), translate('custom.bracelets_twint_balance')])
        column2.push([formatCurrency(this.props.statistics.sold_card || 0), translate('custom.bracelets_card_balance')])        
        column2.push([formatCurrency(-this.props.statistics.unpaid || 0), translate('custom.amounts_offered')])        
        column2.push([formatCurrency(this.props.statistics.unpaid_unused || 0), translate('custom.offer_unused')])
        column2.push([formatCurrency(this.props.statistics.donation || 0), translate('custom.donation')])
        column2.push([formatCurrency(this.props.statistics.debit_mypos_direct || 0), translate('custom.mypos_direct.statistics.consumption')])
        column2.push([formatCurrency(-this.props.statistics.credit_mypos_direct || 0), translate('custom.mypos_direct.statistics.deposit_return')])

        let column1_total = 
            + (this.props.statistics.credit_cash || 0)
            + (this.props.statistics.credit_twint_web || 0)
            + (this.props.statistics.credit_twint_app || 0)
            + (this.props.statistics.credit_twint_other || 0)
            + (this.props.statistics.credit_card_web || 0)
            + (this.props.statistics.credit_card_app || 0)
            - (this.props.statistics.refund_cash || 0)
            - (this.props.statistics.refund_form || 0)
            - (this.props.statistics.refund_twint || 0)
            - (this.props.statistics.refund_card_web || 0)
            - (this.props.statistics.refund_card_app || 0)
            + (this.props.statistics.credit_cash_hybrid || 0)
            + (this.props.statistics.credit_twint_hybrid || 0)
            + (this.props.statistics.credit_card_hybrid || 0)
            + (this.props.statistics.debit_mypos_direct || 0)
            - (this.props.statistics.credit_mypos_direct || 0)

        let column2_total =
            + (this.props.statistics.entrance || 0)
            + (this.props.statistics.consumption || 0)
            + (this.props.statistics.deposit || 0)
            - (this.props.statistics.deposit_return || 0)
            + (this.props.statistics.donation || 0)
            + (this.props.statistics.debit_mypos_direct || 0)
            - (this.props.statistics.credit_mypos_direct || 0)
            + (this.props.statistics.deposit_non_refundable || 0)
            + (this.props.statistics.sold_twint || 0)
            + (this.props.statistics.sold_card || 0)
            + (this.props.statistics.sold_cash || 0)
            - (this.props.statistics.unpaid || 0)
            + (this.props.statistics.unpaid_unused || 0)

        if(column1_total < column2_total) {
            column1.push([formatCurrency(column2_total - column1_total), translate('custom.wristband_payment_adjustment')])
            column1_total = column2_total;
        } else if(column1_total > column2_total) {
            column1.push([formatCurrency(column2_total - column1_total), translate('custom.wristband_sold_adjustment')])
            column1_total = column2_total;
        }

        const column1_without_null = column1.filter(item => item[0] != 0);
        const column2_without_null = column2.filter(item => item[0] != 0);
        const row_data = []
        for (let i=0; i<(column1_without_null.length > column2_without_null.length ? column1_without_null.length : column2_without_null.length); i++) {
            if (column1_without_null[i] && column2_without_null[i]) {
                row_data.push(column1_without_null[i].concat(column2_without_null[i]))
            } else if (column1_without_null[i]) {
                row_data.push(column1_without_null[i].concat(["", ""]))
            } else if (column2_without_null[i]) {
                row_data.push((["", ""]).concat(column2_without_null[i]))
            }
        }

        const footer_data = [
            formatCurrency(column1_total),
            translate('custom.total'),
            formatCurrency(column2_total),
            translate('custom.total')
        ]

        return (
            <div style={{maxWidth: 850, marginLeft: "auto", marginRight: "auto"}}>
                <h1 className={this.props.classes.titleTextStyle}>{translate('custom.movements')}</h1>
                <Box overflow="auto">
                    <Table style={{marginBottom: 20}} >
                        <TableHead className={this.props.classes.table_head} >
                            <TableRow>
                                <TableCell colSpan={2} className={this.props.classes.table_head}>{translate('custom.cash_movements')}</TableCell>
                                <TableCell colSpan={2} className={this.props.classes.table_head}>{translate('custom.turnover')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row_data.map((r_data, r_idx) => (
                                <TableRow
                                    key={r_idx}
                                >
                                    <TableCell className={this.props.classes.table_amount} numeric="true">{r_data[0]}</TableCell>
                                    <TableCell className={this.props.classes.table_row}>{r_data[1]}</TableCell>
                                    <TableCell className={this.props.classes.table_amount} numeric="true">{r_data[2]}</TableCell>
                                    <TableCell className={this.props.classes.table_row}>{r_data[3]}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableHead className={this.props.classes.table_head} >
                            <TableRow>
                                <TableCell className={this.props.classes.table_head_amount} numeric="true">{footer_data[0]}</TableCell>
                                <TableCell className={this.props.classes.table_head}>{footer_data[1]}</TableCell>
                                <TableCell className={this.props.classes.table_head_amount} numeric="true">{footer_data[2]}</TableCell>
                                <TableCell className={this.props.classes.table_head}>{footer_data[3]}</TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </Box>
            </div>
        );
    }
}

const styles = theme => ({
    table_head: {
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText
    },
    table_head_amount: {
        textAlign: 'right',
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText
    },
    table_amount: {
        textAlign: 'right',
        fontSize: 15
    },
    table_row: {
        fontSize: 15
    },
    titleTextStyle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        bold: true,
        marginBottom: 15
    }
});

Account.defaultProps= {
    statistics: {}
};

export default withStyles(styles)(Account);
